<template>
    <b-card header="">
        <h1 class="mb-3">{{ consentData.consentTypeName }}</h1>
        <span v-html="consentData.content"></span>
        <hr>
        <div>
            <b-button v-if="$auth.check() && consentData.requiresApproval" variant="primary" class="save mr-2" @click="onSubmit">
                <i class="fas fa-check"></i> <span class="text">{{ $t('[[[Akceptuj treść regulaminu]]]') }}</span>
            </b-button>
            <b-button class="cancel" variant="light" @click="goBack">{{ $t('[[[Powrót]]]') }}</b-button>
        </div>
    </b-card>
</template>

<script>
import MarketingConsentsService from '@/services/core/MarketingConsentsService';

export default
{
    watch: {
        "$route.params.type": function(newVal, oldVal)
        {
            this.getConsentData(newVal);
        }
    },

    data()
    {
        return {
            consentData:
            {
                id: null,
                consentType: null,
                consentTypeName: '',
                content: '',
                requiresApproval: true
            }
        };
    },

    async created()
    {
        this.getConsentData(this.type);
    },

    computed: {
        type()
        {
            return this.$route.params.type;
        }
    },

    methods: {
        async getConsentData(consentType)
        {
            try
            {
                let response = await MarketingConsentsService.getCurrentConsent(consentType);
                this.consentData = response.data;
            }
            catch (ex)
            {
                if (ex.code === 400)
                {
                    this.$alert.warning(ex.message);
                }

                this.$log.debug(ex);
            }
        },
        async onSubmit()
        {
            try
            {
                MarketingConsentsService.addAcceptance(this.consentData.id);
                this.$alert.success(this.$t('[[[Regulamin został zaakceptowany.]]]'));
            }
            catch (ex)
            {
                if (ex.code === 400)
                    this.$alert.warning(ex.message);

                this.$log.debug(ex);
            }
        },

        goBack()
        {
            this.$router.go(-1);
        }
    }
};
</script>
